import { XIcon } from 'lucide-react';
import React from 'react';

import {
  ConditionalRender,
  Inline,
  Skeleton,
  Typography,
  withTooltip,
} from '@crossnokaye/ux-common';
import {
  Button,
  Header,
  HeaderIcon,
  HeaderRightActions,
  HeaderTitle,
  HeaderTitleGroup,
} from '@crossnokaye/ux-common/ckds';

import { SummaryConfig } from '@repo/sdk/models/components';

import { DeviceIcon } from '@/components/device-icon/device-icon';
import { PrevNextButtons } from '@/features/equipment-browser/equipment-details/page-header/prev-next-buttons';

import { JumpToEquipmentMobileMenu } from './jump-to-mobile-menu/jump-to-equipment-mobile-menu';

const TypographyWithTooltip = withTooltip(Typography);

interface EquipmentDetailsViewProps {
  equipment?: SummaryConfig;
  isLoading?: boolean;
  onClose: () => void;
}

export const EquipmentDetailsPageHeader = ({
  equipment,
  isLoading,
  onClose,
}: EquipmentDetailsViewProps): React.ReactNode => {
  return (
    <ConditionalRender condition={!isLoading && !!equipment} fallback={<Skeletons />}>
      <Header>
        <HeaderIcon>
          <DeviceIcon deviceId={equipment!.referenceId} icon={equipment!.deviceIcon} size="lg" />
        </HeaderIcon>
        <HeaderTitleGroup>
          <HeaderTitle>
            <TypographyWithTooltip
              variant="h1"
              className="truncate"
              tooltipContent={equipment!.title}
            >
              {equipment!.title}
            </TypographyWithTooltip>
          </HeaderTitle>
        </HeaderTitleGroup>
        <HeaderRightActions>
          <PrevNextButtons
            className="hidden @2xl/sidebar:flex @2xl/sidebar:mr-2"
            isLoading={isLoading}
          />
          <JumpToEquipmentMobileMenu className="flex @2xl/sidebar:hidden" />
          <Button variant="tier2" size="md" shape="circle" onClick={onClose}>
            <XIcon className="w-5 h-5" />
          </Button>
        </HeaderRightActions>
      </Header>
    </ConditionalRender>
  );
};

const Skeletons = () => {
  return (
    <Header>
      <HeaderIcon>
        <Skeleton className="w-10 h-9" />
      </HeaderIcon>
      <HeaderTitleGroup>
        <Skeleton className="w-40 h-9" />
      </HeaderTitleGroup>
      <HeaderRightActions>
        <Inline className="h-9">
          <PrevNextButtons className="hidden @2xl/sidebar:flex" isLoading={true} />
          <Skeleton className="w-10 h-10" />
        </Inline>
      </HeaderRightActions>
    </Header>
  );
};
